export enum ComponentTypeData {
    SelectType = "Select Type",
    Cylinder = "Cylinder",
    ConicalShell = "Conical Shell",
    Sphere = "Sphere",
    EllipticalHead = "2:1 Elliptical Head",
    FDHead = "F & D Head",
    B313Piping = "B31.3 Piping",
    B314Piping = "B31.4 Pipeline",
    B318Piping = "B31.8 Piping",
    API650AST = "API 650 AST"
}
export enum MaterialStressData {
    FerriticSteel = "Ferritic steel",
    StainlessSteel = "Stainless steel",
    Duplexss = "Duplex SS",   
    HardNiBasedSS = "Prec. Hard Ni-Based SS",   
    Aluminum = "Aluminum",   
    Copper = "Copper",   
    TiAndZr = "Ti and Zr",
}